import React from "react";
import DishesCard from "./DishesCard";
import { size_list } from "../../helpers/size_list";

const DishesList = ({ dishes }) => {
  return (
    <>
      {dishes.map((item) => {
        return <DishesCard key={item.id} {...item} picksize={size_list} />;
      })}
    </>
  );
};

export { DishesList as default };
